module.exports = __webpack_public_path__ + "static/media/46-web-or-mls-DSC06942.4b12f08d.jpg";